var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import validatorTypesDataForms from '@data-driven-forms/react-form-renderer/dist/cjs/validator-types';
export var validatorTypes = __assign(__assign({}, validatorTypesDataForms), { DATE: "date", CONFIRM_EMAIL: "confirm_email" });
